import Handler from "./Handler";
import DiscussionModel from "../models/DiscussionModel";
import * as Immutable from "immutable";
import CommentModel from "../models/CommentModel";
import RatingModel from "../models/RatingModel";
import UserModel from "../models/UserModel";
import Modifiers from "../models/Modifiers";

export default class LoadHandler extends Handler {

    public handle(model: DiscussionModel, action: string, params?: any): DiscussionModel {
        switch (action) {
            case "load/start":
                return this.handleStart(model, params);
            case "load/data":
                return this.handleData(model, params);
            default:
                return model;
        }
    }

    private handleStart(model: DiscussionModel, params?: any): DiscussionModel {

        this.fetch("load", {
            project: model.getProject(),
            discussion: model.getDiscussion(),
            sort: model.getSort(),
        }).then((response) => {
            if (response.result) {
                this.dispatch("load/data", response.result);
            } else {
                console.error(response.error);
                this.dispatch("error", 1);
            }
        }).catch((error) => {
            console.error(error);
            this.dispatch("error", 1);
        });

        model = model.setLoading(true);
        model = model.clearComments();

        return model;

    }

    private handleData(model: DiscussionModel, data: {
        total: number;
        comments: any[];
        ratings: any[];
        user: any;
        authors: number[];
        admin: boolean;
    }): DiscussionModel {

        const comments = [];
        this.processComments(comments, data.comments, 0);

        model = model.setComments(Immutable.OrderedMap(comments));
        model = model.setRatings(RatingModel.mapArray(data.ratings));
        model = model.setUser(data.user ? new UserModel(data.user) : null);
        model = Modifiers.setAuthors(model, Immutable.Set(data.authors));
        model = Modifiers.setTotal(model, data.total);
        model = Modifiers.setAdmin(model, data.admin || false);
        model = model.setLoading(false);

        return model;

    }

    private processComments(comments: any[], items: any[], level: number): void {

        let previous = false;
        for (let index = 0; index < items.length; index++) {

            const item = items[index];
            const children = item.children || [];

            item.level = level;
            item.first = (index == 0);
            item.last = (index == (items.length - 1));
            item.previous = previous;
            item.children = children.length > 0;
            item.user = item.user ? new UserModel(item.user) : null;

            comments.push([item.comment_id, new CommentModel(item)]);

            if (children.length > 0) {
                this.processComments(comments, children, level + 1);
            }

            previous = item.children;

        }

    }

}